"use client";
import React from "react";
import { Table } from "@/app/(components)/Basic/Table";
import { TableRow } from "@/app/(components)/Basic/TableRow";
import { TableCell } from "@/app/(components)/Basic/TableCell";
import { Date as DateComponent } from "@/app/(components)/Basic/Date";
import NoRecordDialog from "@/app/(components)/Basic/NoRecordDialog";
import { UserBasicData } from "@/app/(components)/Basic/UserBasicData";
import activitiesApi from "@/api/activities/client";
import { NftActivityDescription } from "@/app/(components)/Application/Nft/NftActivityDescription";
import { useQuery } from "@tanstack/react-query";
import { Nft } from "@/api/nfts/types";

import { BaseSignedOrder, OrderType } from "@/api/orders/types";
import { Button } from "@/app/(components)/Basic/Button";
import config from "@/shared/config/client";
import { getUsersName } from "@/api/users/helpers";
import { activityConfigNft } from "@/app/nft/[nftId]/activity/constants";
export interface Props {
  nft: Nft;
  auction: BaseSignedOrder;
}

export default function ReserveActivityTable({ nft, auction }: Props) {
  const { data: activities } = useQuery({
    queryKey: ["reserve-activities", nft.id, auction?.id],
    queryFn: () => {
      if (!auction?.id) return [];
      return activitiesApi.getReserveActivities(auction?.id);
    },
    enabled: auction?.type === OrderType.RESERVE_AUCTION,
  });

  if (auction?.type !== OrderType.RESERVE_AUCTION) {
    return null;
  }

  return (
    <div className="flex flex-col justify-center items-center">
      <Table>
        {activities?.length ? (
          activities.map((activity) => {
            const initiatorImage = {
              src: activity.initiator?.imageUrl,
              width: 90,
              height: 90,
            };
            const initiator = activity.initiator;
            return (
              <TableRow key={activity.id}>
                <TableCell>
                  <UserBasicData
                    user={initiator!}
                    name={getUsersName(initiator, true)}
                    image={initiatorImage}
                    imagePlaceholder={initiator?.imagePlaceholder}
                    subtitle={
                      <NftActivityDescription
                        activity={activity}
                        activityConfig={activityConfigNft}
                      />
                    }
                    subtitleClassName="overflow-visible"
                  />
                </TableCell>
                <TableCell className="lg:w-64">
                  <DateComponent
                    value={activity.createdAt}
                    displayTime={true}
                  />
                </TableCell>
              </TableRow>
            );
          })
        ) : (
          <NoRecordDialog message="No reserve activities for NFT yet" />
        )}
      </Table>
      <Button href={`${config.url}/nft/${nft.id}/activity`} className="mt-4">
        See more
      </Button>
    </div>
  );
}
